import React from 'react';

interface ReadIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const ReadIcon: React.FC<ReadIconProps> = ({ className = '', color = '#0C0E21', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M17.4199 16.3362C19.2137 16.3362 20.6699 14.88 20.6699 13.0862V4.76587C20.6698 4.62646 20.5581 4.51587 20.4199 4.51587C20.2862 4.51597 20.1701 4.63218 20.1699 4.76587V13.0862C20.1699 14.6023 18.936 15.8362 17.4199 15.8362H5.58789L5.34766 16.0764L5.60742 16.3362H17.4199ZM5.17285 14.8362L6.91699 13.093C7.0097 13.0003 7.01066 12.8419 6.92188 12.7463C6.8561 12.6876 6.78843 12.6663 6.74023 12.6663C6.67575 12.6663 6.6148 12.6882 6.56348 12.7395L4.4668 14.8362H5.17285ZM3.58008 16.3362H4.19238L3.93262 16.0764L4.17285 15.8362H3.58008C3.44781 15.8362 3.33279 15.9495 3.33008 16.0813C3.33141 16.1451 3.35745 16.2062 3.40332 16.2522L3.44434 16.2942C3.48386 16.3207 3.53088 16.3362 3.58008 16.3362ZM6.56348 19.4124C6.65821 19.5071 6.82225 19.5071 6.91699 19.4124C7.01127 19.3177 7.01129 19.1545 6.91699 19.0598L5.19238 17.3362H4.4873L6.56348 19.4124Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default ReadIcon;
